import type { LucideIcon } from 'lucide-react';
import {
  MessageSquare,
  BookOpen,
  Target,
  GraduationCap,
  Brain,
  Zap,
} from 'lucide-react';

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  icon: LucideIcon;
  date: string;
  author: string;
  gradient: string;
  iconBg: string;
  readTime: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: 'ai-coaching-agent',
    title: 'Why an AI Coaching Agent Beats Generic Chatbots for Career Growth',
    excerpt: 'Generic chatbots give one-size-fits-all answers. An AI coaching agent that knows your goals, learning path, and progress can deliver personalized advice that actually moves the needle.',
    category: 'AI Coaching',
    icon: MessageSquare,
    date: '2025-02-01',
    author: 'Five AI Team',
    gradient: 'from-primary/10 to-violet-500/10',
    iconBg: 'bg-primary/15 text-primary',
    readTime: '5 min read',
  },
  {
    id: 'micro-learning',
    title: 'Micro Learning: How Bite-Sized Lessons Drive Real Behavior Change',
    excerpt: 'Short, focused lessons you can complete in minutes fit into your day and reinforce skills through repetition. We break down why micro learning works and how Five AI uses it for career development.',
    category: 'Learning',
    icon: BookOpen,
    date: '2025-01-28',
    author: 'Five AI Team',
    gradient: 'from-emerald-500/10 to-teal-500/10',
    iconBg: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
    readTime: '6 min read',
  },
  {
    id: 'soft-skills',
    title: 'Soft Skills Are the New Hard Skills: Communication, Influence, and Leadership',
    excerpt: 'Technical skills get you in the door; soft skills get you promoted. Learn how to build executive communication, stakeholder buy-in, and self-advocacy with structured practice and AI feedback.',
    category: 'Soft Skills',
    icon: Target,
    date: '2025-01-22',
    author: 'Five AI Team',
    gradient: 'from-amber-500/10 to-orange-500/10',
    iconBg: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
    readTime: '7 min read',
  },
  {
    id: 'nudges-habits',
    title: 'Daily Nudges and Habit Stacking for Lasting Career Habits',
    excerpt: 'Small, consistent actions beat occasional intensity. We explore how daily nudges and micro-commitments in the Five AI Coach help you build habits that stick—without burnout.',
    category: 'Habits',
    icon: Zap,
    date: '2025-01-15',
    author: 'Five AI Team',
    gradient: 'from-violet-500/10 to-fuchsia-500/10',
    iconBg: 'bg-violet-500/15 text-violet-600 dark:text-violet-400',
    readTime: '4 min read',
  },
  {
    id: 'personalized-learning-path',
    title: 'Your Personalized Learning Path: Goals, Wins, and 7-Day Sprints',
    excerpt: 'A learning path that adapts to your wins and pain points keeps you motivated. See how we design 7-day sprints with lessons, tips, nudges, and reflection so you see progress fast.',
    category: 'Learning',
    icon: GraduationCap,
    date: '2025-01-08',
    author: 'Five AI Team',
    gradient: 'from-blue-500/10 to-cyan-500/10',
    iconBg: 'bg-blue-500/15 text-blue-600 dark:text-blue-400',
    readTime: '5 min read',
  },
  {
    id: 'ai-and-soft-skills',
    title: 'AI and Soft Skills: Can a Coach in Your Pocket Really Help?',
    excerpt: 'Skeptical about AI for "human" skills? Evidence shows that AI coaching can improve communication, feedback reception, and leadership behaviors when it\'s contextual and actionable.',
    category: 'AI Coaching',
    icon: Brain,
    date: '2025-01-02',
    author: 'Five AI Team',
    gradient: 'from-primary/10 to-violet-500/10',
    iconBg: 'bg-primary/15 text-primary',
    readTime: '6 min read',
  },
];
